/* eslint-disable react/no-unused-state */
import React, { Component, PropTypes } from 'react'
import classnames from 'classnames'
// import Moment from 'moment'
import { format } from 'date-fns'
import Alert from 'components/Alert'
import Table from 'components/Table'
import Heading from 'components/Heading'
import Card from 'components/Card'
import CardFooter from 'components/CardFooter'
import Button from 'components/Button'
import Dialog from 'components/Dialog'
import { hasAccess } from 'utils/hasAccess'
import constants from 'constants'

const styles = Object.assign(
  {},
  require('./PartnerChildrenList.scss'),
  { columns: require('../../columns.scss') },
  { table: require('components/Table/Table.scss') },
)

const headerStyles = classnames(styles.table.unSortable)

class PartnerChildrenList extends Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    deletePartnerChildren: PropTypes.func,
    openPartnerChildrenForm: PropTypes.func,
    partnerChildrenItems: PropTypes.instanceOf(Array),
    partnerChildrens: PropTypes.object.isRequired,
    showEditLink: PropTypes.object.isRequired,
    subHeading: PropTypes.bool,
  }
  static defaultProps = {
    partnerChildrenItems: {},
    deletePartnerChildren: null,
    openPartnerChildrenForm: null,
    subHeading: false,
  }
  constructor(props) {
    super(props)
    this.state = {
      confirmDeleteDialogOpen: false,
      submit: false,
      childrenSelected: '',
    }
  }

  _openConfirmDeleteDialog = (id) => {
    this.setState({ confirmDeleteDialogOpen: true })
    this.setState({ childrenSelected: id })
  }

  _closeConfirmDeleteDialog = () => {
    this.setState({ confirmDeleteDialogOpen: false })
  }

  _saveConfirmDeleteDialog = () => {
    this.setState({
      confirmDeleteDialogOpen: false,
      submit: true,
    })
    this.props.deletePartnerChildren(this.state.childrenSelected)
  }

  renderCols = () => {
    return (
      <tr>
        <th className={classnames(styles.columns.name, headerStyles)}>Name</th>
        <th className={classnames(styles.columns.date_of_birth, headerStyles)}>DOB</th>
        <th className={classnames(styles.columns.actions, headerStyles)} />
      </tr>
    )
  }

  renderData = () => {
    return (
      this.props.partnerChildrenItems.length ?
        this.props.partnerChildrenItems.map(children => (
          <tr className={styles.base} key={children.id}>
            <td className={styles.nameCell}>
              {children.full_name}
            </td>
            <td className={styles.columns.date_of_birth}>
              {children.date_of_birth ? format(new Date(children.date_of_birth), constants.DATE_FORMAT.STANDARD_AU_FULLMONTH) : ''}
            </td>
            <td> {this.props.showEditLink &&
              <div className={styles.buttonContainer}>
                <Button
                  onClick={() => {
                  const selectedItem = {
                    children_id: children.children_id,
                    full_name: children.full_name,
                    date_of_birth: children.date_of_birth,
                  }
                  this.props.openPartnerChildrenForm(selectedItem)
                }}
                  type="flat"
                >
                EDIT
              </Button>
                <Button
                  onClick={() => {
                  this._openConfirmDeleteDialog(children.children_id)
                }}
                  type="flat"
                >
                DELETE
              </Button>
              </div>}
            </td>
          </tr>
        ))
        :
        <tr><td colSpan={4}>
          <div className={styles.noRecord}>
            <div>No Partner children entered</div>
          </div>
        </td></tr>
    )
  }

  render() {
    const confirmDeleteProps = {
      actions: [
        { label: 'CANCEL', onClick: this._closeConfirmDeleteDialog },
        { label: 'DELETE', onClick: this._saveConfirmDeleteDialog },
      ],
      title: 'Are you sure you want to delete this partner children?',
      active: this.state.confirmDeleteDialogOpen,
      onClose: this._closeConfirmDeleteDialog,
    }
    return (
      <div>
        <Heading noTopPadding>Partner&apos;s children</Heading>
        <Card noPadding>
          <Table>
            <thead>
              {this.renderCols()}
            </thead>
            <tbody>
              {this.renderData()}
            </tbody>
          </Table>
          { this.props.showEditLink &&
          <CardFooter>
            <div className={classnames(styles.buttonContainer, styles.flexDirection)}>
              <div className={styles.buttonElement1}>
                <Button
                  className={classnames(styles.buttonAction, styles.buttonLeft, styles.buttonBorder)}
                  onClick={() => {
                    this.props.openPartnerChildrenForm({
                        children_id: '',
                        date_of_birth: '',
                        full_name: '',
                      })
                  }}
                  type="flat"
                >
                Add
              </Button>
              </div>
            </div>
          </CardFooter>
        }
        </Card>
        <Dialog {...confirmDeleteProps}>You will be not able to bring this back once deleted.</Dialog>
      </div>
    )
  }
}

export default PartnerChildrenList



// WEBPACK FOOTER //
// ./src/views/PersonalInfo/components/PartnerChildren/PartnerChildrenList.js